module.exports = __webpack_public_path__ + "static/media/lato-black.768bf332.woff2";